import { useMutation } from "@tanstack/react-query";
import { callFunction } from "../lib/api";
import { mapResponse, ResponseRow } from "../lib/match";
import { Response } from "../types";

interface AddResponsePayload {
  matchId: string;
  name: string;
  userId?: string;
  status?: "confirmed" | "rejected";
}

export const useAddResponse = () => {
  return useMutation({
    mutationFn: async (payload: AddResponsePayload): Promise<Response> => {
      const data = (await callFunction("/add-response", {
        method: "POST",
        body: JSON.stringify({
          matchId: payload.matchId,
          name: payload.name,
          status: payload.status ?? "confirmed",
          userId: payload.userId,
        }),
      })) as ResponseRow;

      return mapResponse(data);
    },
  });
};
